/**
 * @file 首页
 * @author chenyuyang
 */
// @ts-nocheck

import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';
import {recordProxy} from '../../util';
import {fetchCreateTopic} from '../../actions/homeAction';
import {helpList} from './constans';
import needLoginList from '../../constants/needLoginList';
import dfxaf from '@baidu/antifraud-xaf3';

import imgBanner from './imgs/banner.png';
import brandImg from './imgs/brand-img2.png';
import imgCancelMark from './imgs/cancelMark.png';
import imgAppeal from './imgs/appeal.png';
import imgEvaluation from './imgs/evaluation.png';
import imgModifyInfo from './imgs/modify-info.png';
import imgMark from './imgs/mark.png';
import './style.less';

export class NewHome extends React.Component<any, any> {
    static propTypes = {
        match: PropTypes.object,
        userInfo: PropTypes.object,
        history: PropTypes.object,
        fetchCreateTopic: PropTypes.func
    };
    constructor(prop: any) {
        super(prop);
    }

    componentDidMount() {
        dfxaf.init({
            aid: '5678'
        });
        window.scrollTo(0, 0);
    }
    login = () => {
        const isDev = window.location.href.indexOf('haoma.baidu.com') > -1 ? false : true;
        const ele = document.createElement('a');
        ele.href = `https://passport${isDev ? '.qatest' : ''}.baidu.com/v2/?login&u=${
            window.location.href
        }`;
        ele.click();
    };
    jump = (item) => {
        const {userInfo = {}} = this.props;
        recordProxy('newHome', 'click', item.routerPath.replace('/', ''));
        if (needLoginList.includes(item.routerPath) && userInfo.code !== 200) {
            this.login();
        } else {
            const pagef = item.type ? item.type : 'home-bottom';
            this.props.history.push(item.routerPath + `?pagef=${pagef}`);
        }
    };
    render() {
        return (
            <div className="page-home">
                <div className="banner-wrapper">
                    <div className="banner">
                        <img src={imgBanner} className="banner-img" />
                        <div className="brand-info">
                            <p className="info">百度旗下</p>
                            <p className="info">一站式号码服务平台</p>
                            <p className="brand-tip">基于百度搜索和AI模型   权威可信可追溯   提供一站式服务</p>
                        </div>
                    </div>
                    <div className="bottom-bg"></div>
                </div>
                <p className="introduce">
                    百度号码服务平台基于百度搜索和AI模型，
                    在百度搜索结果展示企业专属认证，在企业与用户间建立权威、高效的信息桥梁。
                    同时为全网用户提供号码查询、申诉、标记、报错、反馈等更多功能，一站式解决所有号码需求。
                </p>
                <div className="brand-detail">
                    <p className="brand-detail-title">企业官方号码认证 打造权威品牌形象</p>
                    <div className="brand-detail-content">
                        <div className="brand-detail-list-wrapper">
                            <div className="brand-detail-list">
                                <p className="brand-detail-list-title">百度搜索结果卡片</p>
                                <p className="brand-detail-list-tip">百度旗下专业安全产品认证,<br/>杜绝冒用</p>
                            </div>
                            <div className="brand-detail-list center">
                                <p className="brand-detail-list-title">企业专属号码名片</p>
                                <p className="brand-detail-list-tip">为企业打造个性化“电子名片”, <br/>建立品牌形象</p>
                            </div>
                            <div className="brand-detail-list">
                                <p className="brand-detail-list-title">多平台来电显示</p>
                                <p className="brand-detail-list-tip">企业品牌在用户接通来电时进行展示,<br/>提升外呼接通率</p>
                            </div>
                        </div>
                        <img className="brand-img" src={brandImg}/>
                        <div className="more-btn-wrapper">
                            <div className="badge">限时优惠</div>
                            <button className="more-btn"
                                onClick={() => this.jump({routerPath: '/attest'})}>了解更多</button>
                        </div>
                    </div>
                </div>
                <div className="report-mark-wrap">
                    <div className="report-mark">
                        <div className="report-title">百度携手12321共建号码安全</div>
                        <div className="report-title">帮助更多用户识别号码问题</div>
                        <div className="report-tip">对骚扰、诈骗等号码进行投诉举报</div>
                        <button
                            className="more-service-list-btn"
                            onClick={() => this.jump({routerPath: '/mark', type: 'home-banner'})}
                        >
                            投诉号码
                        </button>
                    </div>
                </div>
                <div className="more-service">
                    <p className="service-title">更多号码服务  满足更多需求</p>
                    <div className="more-service-list-wrapper">
                        <div className="more-service-list">
                            <img className="more-service-list-banner" src={imgMark}/>
                            <p className="more-service-list-title">12321号码投诉</p>
                            <div className="more-service-list-tip">
                                <p>百度&12321合作共建不良号码举报，</p>
                                <p>骚扰诈骗投诉会同步12321处理</p>
                            </div>
                            <button className="more-service-list-btn"
                                onClick={() => this.jump({routerPath: '/mark'})}>立即前往</button>
                        </div>
                        <div className="more-service-list">
                            <img className="more-service-list-banner" src={imgCancelMark}/>
                            <p className="more-service-list-title">号码标记申诉</p>
                            <div className="more-service-list-tip">
                                <p>您的个人/企业号码被错误标记</p>
                                <p>为骚扰或推销等，可申诉取消</p>
                            </div>
                            <button className="more-service-list-btn"
                                onClick={() => this.jump({routerPath: '/appeal'})}>立即前往</button>
                        </div>
                        <div className="more-service-list">
                            <img className="more-service-list-banner" src={imgAppeal}/>
                            <p className="more-service-list-title">号码占用申诉</p>
                            <p className="more-service-list-tip">解决号码被侵占问题，如: 个人号码被企业占用</p>
                            <button className="more-service-list-btn"
                                onClick={() => this.jump({routerPath: '/occupy'})}>立即前往</button>
                        </div>
                    </div>
                    <div className="more-service-list-wrapper2">
                        <div className="more-service-list">
                            <img className="more-service-list-banner" src={imgModifyInfo}/>
                            <p className="more-service-list-title">认证信息修改</p>
                            <p className="more-service-list-tip">对已认证企业 / 政府号码的修改、删除、新增</p>
                            <button className="more-service-list-btn"
                                onClick={() => this.jump({routerPath: '/verify_msg'})}>立即前往</button>
                        </div>
                        <div className="more-service-list">
                            <img className="more-service-list-banner" src={imgEvaluation}/>
                            <p className="more-service-list-title">号码质量反馈</p>
                            <div className="more-service-list-tip">
                                <p>反馈您在使用号码平台时遇到</p>
                                <p>的号码错误，号码空号等问题</p>
                            </div>
                            <button className="more-service-list-btn"
                                onClick={() => this.jump({routerPath: '/feedback'})}>立即前往</button>
                        </div>
                    </div>
                    <div className="help-service">
                        <p className="service-title help-service-title">帮助与支持</p>
                        <div className="help-content">
                            {helpList.map((item, index) => {
                                return (<div className="help-service-list" key={index} onClick={() => this.jump(item)}>
                                    <span>{item.text}</span>
                                    <span className="arrow"></span>
                                </div>);
                            })}
                            <button className="more-help" onClick={() => this.jump({routerPath: '/help'})}>更多帮助</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state: any) {
    return {
        userInfo: state.userInfo
    };
}

function mapDispatchToProps(dispatch: Function) {
    return {
        fetchCreateTopic: (type: any, obj: any) => fetchCreateTopic(dispatch, obj)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(NewHome));
